var allRticsPage = function () {
    function pageBodyLoad() {
        checkUserStatus();
    }

    // Check user is valid and logged in
    function checkUserStatus() {
        let method, url, input;

        method = "GET";
        url = "../api/user/user_actions.php?action=check_user";

        const checkUserStatusSuccess = function (response) {
            const responseParsed = JSON.parse(response);
            if (responseParsed.logged_in == true) {
                coreFunctions.userguidingSetup(responseParsed);
                allRtics.getAllRtics(); // Valid user
            } else {
                requireLogin();
            }
        }

        const checkUserStatusError = function () {
            // Redirect page back to login
            requireLogin();
        }

        coreFunctions.xhrHelper(method, url, checkUserStatusSuccess, checkUserStatusError, input);
    }

    class AllRtics {
        constructor() {
            this.rtics = [];
            this.rticsSummaryTableHeadings = [{
                field: "code",
                name: "Code",
                tooltip: null,
                dataType: "string"
            }, {
                field: "title",
                name: "Name",
                tooltip: null,
                dataType: "string"
            },  {
                field: "created",
                name: "Created",
                tooltip: null,
                dataType: "datetime"
            },  {
                field: "revised",
                name: "Revised",
                tooltip: null,
                dataType: "datetime"
            }, {
                field: "region",
                name: "Region",
                tooltip: null,
                dataType: null
            }, {
                field: "totalCompanies",
                name: "Count",
                tooltip: "Total companies in RTIC sector",
                dataType: "number"
            }, {
                field: "womenFoundedCompanies",
                name: "Women founded<br>companies",
                tooltip: "Total companies founded by women",
                dataType: "number"
            }, {
                field: "bestEstimateTotalTurnover",
                name: "Total turnover",
                tooltip: "Best estimate of total turnover",
                dataType: "number"
            }, {
                field: "bestEstimateTotalEmployees",
                name: "Total employees",
                tooltip: "Best estimate of total employees",
                dataType: "number"
            }, {
                field: "totalDealroomFunding",
                name: "Investment",
                tooltip: "Total investment funding provided by Dealroom",
                dataType: "number"
            }, {
                field: "totalInnovateUkFunding",
                name: "Grant funding",
                tooltip: "Total Innovate UK grant funding",
                dataType: "number"
            }, {
                field: "bestEstimateGrowthPercentagePerYear",
                name: "Growth",
                tooltip: "Estimated growth per year",
                dataType: "number"
            }

        ];
            this.directoryCompanyClaimRequestsTableHeadings = [];
        }

        downloadRticsSummary() {
            const csv = Papa.unparse(this.formatRticsDataForDownload());
            const blob = new Blob([csv]);
            const a = window.document.createElement("a");
            a.href = window.URL.createObjectURL(blob, {
                type: "text/plain"
            });
            a.download = this.formatDownloadFilename();
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }

        formatDownloadFilename() {
            return `RTICs_${document.getElementById("rticsSummaryRegionSelect").value.replace(" (England)", "").replace(/ /g, "_")}.csv`;
        }

        formatRticsDataForDownload() {
            return this.rtics.map(rtic => rtic.getDownloadData());
        }

        // Create a new director and save it in the collection
        newRtic(title, subsectors, totalCompanies, revised, locked, created, code, description) {
            let rtic = new Rtic(title, subsectors, totalCompanies, revised, locked, created, code, description);
            this.rtics.push(rtic);
            return rtic;
        }

        getAllRtics() {
            let method, url;
            const rticsObject = this;

            method = "GET";
            url = "../api/rtics/rtics_actions.php?action=get_rtics"

            const getRticsSuccess = function (response) {
                let getRticsResponse = JSON.parse(response);
                rticsObject.processRtics(getRticsResponse).getRticsSummary("UK", true);
            }

            const getRticsError = function (response) {

            }

            coreFunctions.xhrHelper(method, url, getRticsSuccess, getRticsError);
        }

        processRtics(rtics) {
            rtics.sort((a, b) => a.title.localeCompare(b.title)).forEach(rtic => allRtics.newRtic(rtic.title, rtic.members, rtic.companies, rtic.revised, rtic.locked, rtic.created, rtic.code, rtic.description).addRticVerticals(rtic.verticals).addRticElementsToPage());
            return this;
        }

        getRticsSummary(region, includeRegions) {
            let method, url;
            const self = this;
            document.getElementById("rticsSummaryRegionSelect").disabled = true;
            method = "GET";
            url = `../api/rtics/rtics_actions.php?action=get_rtics_summary&region=${region}&includeregions=${includeRegions}`

            const getRticsSummarySuccess = function (response) {
                let rticsSummaryResponse = JSON.parse(response);
                document.getElementById("rticsSummaryRegionSelect").disabled = false;
                coreFunctions.checkForDebugMessages(rticsSummaryResponse);
                self.processUkRegions(rticsSummaryResponse.nuts1Regions).processRticsSummary(rticsSummaryResponse.rticsSummary).addRticsSummaryToTable().populateRticsTomSelect();
                document.getElementById("main").classList.remove("mainHidden");
            }

            const getRticsSummaryError = function (response) {

            }

            coreFunctions.xhrHelper(method, url, getRticsSummarySuccess, getRticsSummaryError);
        }

        processUkRegions(nuts1Regions) {
            if (nuts1Regions != undefined) {
                nuts1Regions.forEach(region => {
                    if (region.length > 0) {
                        document.getElementById("rticsSummaryRegionSelect").appendChild(coreFunctions.createElementHelper("option", {innerHTML: region, value: region}));
                    }
                })
            }
            return this;
        }

        processRticsSummary(rticsSummaries) {
            const self = this;
            rticsSummaries.forEach(summary => {
                let rticSectorMatch;
                // Only process summary for RTIC sector
                if (summary.ModelCode.length == 8 && (rticSectorMatch = self.rtics.find(element => element.code == summary.ModelCode))) {
                    rticSectorMatch.addRticSummaryDetails(summary);
                }
            })
            return this;
        }

        addRticsSummaryToTable() {
            let tableHead = document.getElementById("rticsSummaryTableHead");
            if (tableHead.childNodes.length === 0) {
                this.createTableHeader(tableHead, this.rticsSummaryTableHeadings);
            }
            document.querySelector(".sortTableButton[data-field='code']").dataset.sortdirection = "asc"; // Reset state of sort by RTIC code
            this.populateTableBody(document.getElementById("rticsSummaryTableBody"), this.rtics).sortTable(document.querySelector(".sortTableButton[data-field='code']"));
            return this;
        }

        populateRticsTomSelect() {
            const options = this.rtics.map(element => element.getRticSectorTomSelectOptions());
            new TomSelect("#rticsSelect", {
                options: options,
                labelField: "name",
                searchField: ["name", "value", "sectorName"],
                openOnFocus: true,
                closeAfterSelect: true,
                onItemAdd: (value, $item) => this.rticsTomSelectOnItemAdd(value, $item),
                render: {
                    option: function(data, escape) {
                        return `<div class="rtics-select-option" data-code="${escape(data.value)}" data-type="${escape(data.type)}">
                                    <div class="rtic-code">${escape(data.value)}</div>
                                    <div class="flex-row-holder">
                                        <div class="flex-grow rtic-name">${escape(data.name)}</div>
                                        <div class="rtic-type">${escape(data.type)}</div>
                                    </div>
                                    <div class="rtic-sector-name">${escape(data.sectorName)}</div>
                                </div>`
                    },
                    item: function(data, escape) {
                        return `<div class="rtic-select-item" data-type="${escape(data.type)}" data-rtic_sector_code="${escape(data.sectorCode)}">${escape(data.name)}</div>`;
                    }
                }
            });
            return this;
        }

        rticsTomSelectOnItemAdd(value, $item) {
            const rticType = $item.dataset.type;
            const rticSectorCode = $item.dataset.rtic_sector_code;
            const rticSectorObj = this.rtics.find(element => element.code == rticSectorCode);
            if (rticType == "vertical") {
                const rticVerticalObj = rticSectorObj.verticals.find(element => element.code == value);
                rticSectorObj.showRticSectorExtraDetails(false);
                rticVerticalObj.showRticSectorExtraDetails(true);
            } else {
                rticSectorObj.showRticSectorExtraDetails(true);
            }
            return this;
        }

        searchLists() {
            let listSearchString, totalRtics;

            listSearchString = document.getElementById("listSearchInput").value.toLowerCase();
            totalRtics = this.rtics.length;
            for (var i = 0; i < totalRtics; i++) {
                this.rtics[i].rticSearch(listSearchString);
            }

            // No lists pass the search criteria
            if (document.querySelector(".existingList:not(.hidden)") == undefined) {
                document.getElementById("listSearchNoResults").classList.remove("hidden");
            } else {
                document.getElementById("listSearchNoResults").classList.add("hidden");
            }
        }

        resetLists() {
            this.rtics.forEach(rtic => rtic.showRticListElement());
        }

        toggleRticsPage() {
            document.getElementById("allRticsListPage").classList.toggle("hidden");
            document.getElementById("allRticsSummaryPage").classList.toggle("hidden");
        }

        createTableHeader(holder, headings) {
            const self = this;
            headings.forEach(heading => {
                const th = holder.appendChild(coreFunctions.createElementHelper("th"));
                const thContent = th.appendChild(coreFunctions.createElementHelper("div", {class:"flex-row-holder align-top"}));
                const thTitle = thContent.appendChild(coreFunctions.createElementHelper("span", {class: "thTitle", innerHTML: heading.name, "data-field": heading.field}));
                if (heading.tooltip) {
                    thTitle.appendChild(coreFunctions.createElementHelper("span", {class: "thTooltip", innerHTML: heading.tooltip}));
                }
                if (heading.dataType) {
                    thContent.appendChild(coreFunctions.createElementHelper("button", {innerHTML: "&nbsp;", class:"sortTableButton", "data-field": heading.field, "data-objectfield": heading.objectField, "data-datatype": heading.dataType, "data-sortdirection": (heading.dataType == "number") ? "desc" : "asc" }, {click: function(event) {self.sortTable(this)}}));
                }
            });
        }

        populateTableBody(holder, elements) {
            coreFunctions.clearElementChildren(holder);
            elements.forEach(element => holder.appendChild(element.createTableRow()));
            return this;
        }

        sortTable(element) {
            let field, sortType, sortDirection, sortFactor, sortedArray;
            field = element.dataset.field;
            sortType = element.dataset.datatype;
            sortDirection = element.dataset.sortdirection;
            sortFactor = (sortDirection == "asc") ? 1 : -1; // Take into account ascending or descending direction

            sortedArray = this.rtics.sort(function (a, b) {
                if (sortType == "datetime") {
                    if (moment(a[field]).isBefore(moment(b[field])) || a[field] == null) {
                        return -1 * sortFactor;
                    }
                    if (moment(a[field]).isAfter(moment(b[field])) || b[field] == null) {
                        return 1 * sortFactor;
                    }
                    return 0;
                } else if (sortType == "string") {
                    if (a[field] < b[field]) {
                        return -1 * sortFactor;
                    }
                    if (a[field] > b[field]) {
                        return 1 * sortFactor;
                    }
                    return 0;
                } else if (sortType == "number") {
                    if (Number(a[field]) < Number(b[field])) {
                        return -1 * sortFactor;
                    }
                    if (Number(a[field]) > Number(b[field])) {
                        return 1 * sortFactor;
                    }
                    return 0;
                }
            });

            element.dataset.sortdirection = (sortDirection == "asc") ? "desc" : "asc";
            this.populateTableBody(element.closest("table").querySelector("tbody"), sortedArray);
        }
    }

    class Rtic {
        totalDealroomFunding;
        totalDealroomRoundsOfFunding;
        totalInnovateUkFunding;
        totalInnovateUkGrantsWon;
        bestEstimateGrowthPercentagePerYear;
        bestEstimateTotalEmployees;
        bestEstimateTotalEmployeesCompaniesUsed;
        bestEstimateTotalTurnover;
        bestEstimateTotalTurnoverCompaniesUsed;
        summaryCompaniesConsidered;
        womenFoundedCompanies;

        constructor(title, subsectors, totalCompanies, revised, locked, created, code, description) {
            this.title = title;
            this.code = code;
            this.subsectors = subsectors;
            this.totalCompanies = totalCompanies;
            this.revised = revised;
            this.created = created;
            this.description = description;
            this.locked = locked;
            this.region = null;
            this.verticals = [];
            this.growthNumberFormat = new Intl.NumberFormat('en', { style: 'percent', signDisplay: 'exceptZero', minimumSignificantDigits: 2});
        }

        addRticVerticals(verticals) {
            const rticObject = this;
            verticals.forEach(vertical => rticObject.newVertical(vertical.name, vertical.code, vertical.description, vertical.companies));
            return this;
        }

        getDownloadData() {
            return {
                "RTIC code": this.code,
                "RTIC name": this.title,
                "Created date": this.created,
                "Revised date": this.revised,
                "Companies count": this.totalCompanies,
                "Total turnover (GBP)": this.bestEstimateTotalTurnover,
                "Total employees": this.bestEstimateTotalEmployees,
                "Investment funding (GBP)": this.totalDealroomFunding,
                "Innovate UK grant funding (GBP)": this.totalInnovateUkFunding,
                "Fractional growth": this.bestEstimateGrowthPercentagePerYear
            }
        }

        getRticSectorTomSelectOptions() {
            const sectorOption = {
                value: this.code,
                name: this.title,
                sectorCode: this.code,
                sectorName: this.title,
                type: "sector"
            };
            const verticalOptions = this.verticals.map(element => element.getRticVerticalTomSelectionOption());
            verticalOptions.unshift(sectorOption);
            return verticalOptions;
        }

        newVertical(name, code, description, companies) {
            let newVertical = new RticVertical(name, code, description, companies, this.title, this.code, this.locked);
            this.verticals.push(newVertical);
            return newVertical;
        }

        addRticSummaryDetails(rticSummary) {
            this.totalDealroomFunding = rticSummary.TotalDealroomFunding  * 1000000; // Dealroom data is in millons of pounds
            this.totalDealroomRoundsOfFunding = rticSummary.TotalDealroomRoundsOfFunding;
            this.totalInnovateUkFunding = rticSummary.TotalInnovateUKFunding;
            this.totalInnovateUkGrantsWon = rticSummary.TotalInnovateUKGrantsWon;
            this.bestEstimateGrowthPercentagePerYear = rticSummary.BestEstimateGrowthPercentagePerYear;
            this.bestEstimateTotalEmployees = rticSummary.BestEstimateTotalEmployees;
            this.bestEstimateTotalEmployeesCompaniesUsed = rticSummary.BestEstimateTotalEmployeesCompaniesUsed;
            this.bestEstimateTotalTurnover = rticSummary.BestEstimateTotalTurnover;
            this.bestEstimateTotalTurnoverCompaniesUsed = rticSummary.BestEstimateTotalTurnoverCompaniesUsed;
            this.summaryCompaniesConsidered = rticSummary.CompaniesConsidered;
            this.womenFoundedCompanies = rticSummary.WomenFoundedCompanies;
            this.region = rticSummary.Region
        }

        createTableRow() {
            let tableRow = coreFunctions.createElementHelper("tr", {"data-rticcode": this.code });
            //.format(number))

            const tdAnalysisElement = coreFunctions.createElementHelper("td", { "data-field": "code" });
            tdAnalysisElement.appendChild(coreFunctions.createElementHelper("a", {
                title: "See RTIC analysis",
                class: 'rtic_analysis',
                innerHTML: "&nbsp;",
                href: `${urlPath}/analyse?rtic=${encodeURIComponent(this.code)}`
            }));
            tdAnalysisElement.appendChild(coreFunctions.createElementHelper("a", {
                innerHTML: this.code,
                class: 'rtic-list',
                href: `${urlPath}/explore?rtic=${encodeURIComponent(this.code)}`
            }));
            tableRow.appendChild(tdAnalysisElement);

            // If the RTIC has not been revised, we set the revised date to the created date
            let revisedDate = this.revised;
            if(!revisedDate) {
                revisedDate = this.created;
            }
            tableRow.appendChild(coreFunctions.createElementHelper("td", {innerHTML: this.title, "data-field": "title"}));
            tableRow.appendChild(coreFunctions.createElementHelper("td", {innerHTML: moment(this.created, "YYYY-MM-DD").format("DD/MM/YY"), "data-field": "created"}));
            tableRow.appendChild(coreFunctions.createElementHelper("td", {innerHTML: moment(revisedDate, "YYYY-MM-DD").format("DD/MM/YY"), "data-field": "revised"}));
            tableRow.appendChild(coreFunctions.createElementHelper("td", {innerHTML: this.region, "data-field": "region"}));
            tableRow.appendChild(coreFunctions.createElementHelper("td", {innerHTML: (this.summaryCompaniesConsidered) ? this.summaryCompaniesConsidered.toLocaleString() : "Unknown", "data-field": "totalCompanies"}));
            tableRow.appendChild(coreFunctions.createElementHelper("td", {innerHTML: (this.womenFoundedCompanies) ? this.womenFoundedCompanies.toLocaleString() : "Unknown", "data-field": "womenFoundedCompanies"}));
            tableRow.appendChild(coreFunctions.createElementHelper("td", {innerHTML: this.formatNumericalValue("bestEstimateTotalTurnover", "currency"), "data-field": "bestEstimateTotalTurnover"}));
            tableRow.appendChild(coreFunctions.createElementHelper("td", {innerHTML: this.formatNumericalValue("bestEstimateTotalEmployees", "number"), "data-field": "bestEstimateTotalEmployees"}));
            tableRow.appendChild(coreFunctions.createElementHelper("td", {innerHTML: this.formatNumericalValue("totalDealroomFunding", "currency"), "data-field": "totalDealroomFunding"}));
            tableRow.appendChild(coreFunctions.createElementHelper("td", {innerHTML: this.formatNumericalValue("totalInnovateUkFunding", "currency"), "data-field": "totalInnovateUkFunding"}));
            //tableRow.appendChild(coreFunctions.createElementHelper("td", {innerHTML: `+${Number(this.bestEstimateGrowthPercentagePerYear * 100).toFixed(1)}%`, "data-field": "bestEstimateGrowthPercentagePerYear"}));
            tableRow.appendChild(coreFunctions.createElementHelper("td", {innerHTML: this.growthNumberFormat.format(Number(this.bestEstimateGrowthPercentagePerYear * 1)), "data-field": "bestEstimateGrowthPercentagePerYear"}));
            return tableRow;
        }

        formatNumericalValue(field, dataType) {
            let count = this[field];

            if (count != undefined) {
                let formattedValue = Math.abs(count);
                const si = [
                    {
                        value: 1,
                        symbol: ""
                    },
                    {
                        value: 1E3,
                        symbol: "k"
                    },
                    {
                        value: 1E6,
                        symbol: "M"
                    },
                    {
                        value: 1E9,
                        symbol: "bn"
                    },
                    {
                        value: 1E12,
                        symbol: "T"
                    },
                    {
                        value: 1E15,
                        symbol: "P"
                    },
                    {
                        value: 1E18,
                        symbol: "E"
                    }
                ];

                let i;
                for (i = si.length - 1; i > 0; i--) {
                    if (formattedValue >= si[i].value) {
                        break;
                    }
                }

                if (dataType == "currency") {
                    let currency = "&pound"; // Currency unit is in pounds
                    if (count < 0) {
                        formattedValue = Number(Math.abs((count / si[i].value).toFixed(1))).toLocaleString() + si[i].symbol;
                        formattedValue = `<span class='orange'>-${currency}${formattedValue}</span>`;
                    } else {
                        formattedValue = parseFloat((count / si[i].value).toFixed(1)).toLocaleString() + si[i].symbol;
                        formattedValue = `${currency}${formattedValue}`;
                    }
                } else {
                    formattedValue = parseFloat((count / si[i].value).toFixed(1)).toLocaleString() + si[i].symbol;
                }
                return formattedValue;
            } else {
                return "Unknown";
            }
        }

        addRticElementsToPage() {
            let rticList, actionsHolder, listDetailsElement, extraDetailsHolder, extraReleaseTag, accordianListMain, listAnchorLink;
            const rticsObject = this;

            rticList = coreFunctions.createElementHelper("li", {
                class: "existingList",
                rtic_name: this.title,
                "data-code": this.code
            });

            accordianListMain = rticList.appendChild(coreFunctions.createElementHelper("div", {class:"accordian-list-main"}));

            accordianListMain.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-control-holder"})).appendChild(coreFunctions.createElementHelper("button", {
                class: "actionControl extraDetailsButton",
                innerHTML: "&nbsp;"
            }, {
                click: function () {
                    rticsObject.extraDetailsButtonClick(this);
                }
            })); // Show extra details button

            listDetailsElement = accordianListMain.appendChild(coreFunctions.createElementHelper("div", {
                class: "listDetailsElement accordian-list-name",
            }));

            actionsHolder = accordianListMain.appendChild(coreFunctions.createElementHelper("div", {
                class: "accordian-control-holder actionsHolder"
            }));

            listAnchorLink = listDetailsElement.appendChild(coreFunctions.createElementHelper("a", {
                title: "See full list",
                class: `existingListName${(this.locked) ? " rticLocked": ""}`,
                href: `${(this.locked) ? "": `${urlPath}/explore?rtic=${encodeURIComponent(this.code)}`}`,
                innerHTML: `<span>${this.title}</span>`
            }));

            if (extraReleaseTag = this.checkRticExtraReleaseTag()) {
                listAnchorLink.appendChild(coreFunctions.createElementHelper("span", {
                    class: "rticReleaseTag",
                    innerHTML: extraReleaseTag
                }));
            }

            if (this.locked === true) {
                listAnchorLink.appendChild(coreFunctions.createElementHelper("button", {
                    class: "unlock",
                    innerHTML: "subscribe to unlock"
                }, {
                    click: function () {
                        coreFunctions.showOverlay("subscribe")
                    }
                }));
            }

            extraDetailsHolder = rticList.appendChild(coreFunctions.createElementHelper("ul", {
                class: "extraDetailsHolder accordian-list-details"
            }));
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {
                innerHTML: `<div class='label'>Code</div><div class='field'>${this.code}</div>`
            }));
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {
                innerHTML: `<div class='label'>Created</div><div class='field'>${moment(this.created, "YYYY-MM-DD").format("DD/MM/YY")}</div>`
            }));
            if (this.revised) {
                extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {
                    innerHTML: `<div class='label'>Revised</div><div class='field'>${moment(this.revised, "YYYY-MM-DD").format("DD/MM/YY")}</div>`
                }));
            }
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {
                innerHTML: `<div class='label'>Companies</div><div class='field'>${this.totalCompanies.toLocaleString()}</div>`
            }));
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {
                innerHTML: `<div class='label'>Description</div><div class='field'>${(this.description) ? this.description : "Unavailable"}</div>`
            }));

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {
                innerHTML: `<div class='label'>Verticals</div>`
            })) // Verticals label

            // TODO Sort out missing verticals
            this.verticals.filter(element => element.name).sort((a, b) => a.name.localeCompare(b.name)).forEach(vertical => extraDetailsHolder.appendChild(vertical.addRticVerticalElements()));

            listAnchorLink.appendChild(coreFunctions.createElementHelper("span", {
                class: "rticCompaniesTotal",
                innerHTML: `${this.totalCompanies.toLocaleString()} companies`
            }));
            actionsHolder.appendChild(coreFunctions.createElementHelper("a", {
                innerHTML: "&nbsp;",
                title: "See RTIC analysis",
                class: "rtic_analysis",
                href: `${urlPath}/analyse?rtic=${this.code}`
            }));

            document.getElementById("allRtics").appendChild(rticList);
            return this;
        }

        checkRticExtraReleaseTag() {
            // Created in the last month
            if (moment().diff(moment(this.created, "YYYY-MM-DD"), "months") == 0) {
                return "New";
            }
            // Revised in the last month
            else if (this.revised && moment().diff(moment(this.revised, "YYYY-MM-DD"), "months") == 0) {
                return "Revised";
            } else {
                return false;
            }

        }

        extraDetailsButtonClick(element) {
            element.closest(".existingList").classList.toggle("extraDetailsVisible");
            return this;
        }

        showRticSectorExtraDetails(scrollToElement = false) {
            let listElement;
            if (listElement = document.querySelector(`#existingListsSection .existingList[data-code='${this.code}']`)) {
                let scrollTimeout = listElement.classList.contains("extraDetailsVisible") ? 0 : 500;
                listElement.classList.add("extraDetailsVisible");
                if (scrollToElement) {
                    setTimeout(() => this.scrollToRticVerticalElement(listElement), scrollTimeout);
                }
            }
            return this;
        }

        scrollToRticVerticalElement(element) {
            element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            return this;
        }

        rticSearch(searchString) {
            const code = this.code.toLowerCase();
            const title = this.title.toLowerCase();
            let verticalExactMatch;

            if (title.includes(searchString)) {
                this.showRticListElement();
            } else if (code.includes(searchString)) {
                this.showRticListElement();
            } else if (this.searchStringMatchesVerticals(searchString)) {
                this.showRticListElement();
                if (verticalExactMatch = this.getVerticalSearchExactMatch(searchString)) {
                   this.showRticSectorExtraDetails();
                   verticalExactMatch.showRticSectorExtraDetails();
                }
            } else {
                this.hideRticListElement();
            }
        }

        getVerticalSearchExactMatch(searchString) {
            // Check for exact match in code, case insensitive
            return this.verticals.find(element => element.code.localeCompare(searchString, undefined, { sensitivity: 'accent' }) === 0);
        }

        searchStringMatchesVerticals(searchString) {
            return this.verticals.find(element => element.code.toLowerCase().startsWith(searchString)) != undefined;
        }

        showRticListElement() {
            document.querySelector(`.existingList[rtic_name='${this.title}']`).classList.remove("hidden");
        }

        hideRticListElement() {
            document.querySelector(`.existingList[rtic_name='${this.title}']`).classList.add("hidden");
        }
    }

    class RticVertical {
        constructor(name, code, description, companies, sectorName, sectorCode, locked) {
            this.name = name;
            this.code = code;
            this.description = description;
            this.companies = companies;
            this.sectorName = sectorName;
            this.sectorCode = sectorCode;
            this.locked = locked;
        }

        getRticVerticalTomSelectionOption() {
            return {
                value: this.code,
                name: this.name,
                sectorCode: this.sectorCode,
                sectorName: this.sectorName,
                type: "vertical"
            }
        };

        addRticVerticalElements() {
            const rticVerticalsObject = this;
            let rticVerticalsHolder, rticVerticalDetailsElement, extraDetailsHolder, accordianListMain;
            rticVerticalsHolder = coreFunctions.createElementHelper("li", {
                class: "existingList rticVerticalHolder accordian-list-tier-two",
                "data-code": this.code
            });

            accordianListMain = rticVerticalsHolder.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-list-main"}));

            accordianListMain.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-control-holder"})).appendChild(coreFunctions.createElementHelper("button", {
                class: "actionControl extraDetailsButton rticVerticalExtraDetailsButton",
                innerHTML: "&nbsp;"
            }, {
                click: function () {
                    rticVerticalsObject.extraDetailsButtonClick(this)
                }
            })); // Show extra details button

            rticVerticalDetailsElement = accordianListMain.appendChild(coreFunctions.createElementHelper("div", {
                class: "listDetailsElement accordian-list-name"
            }));

            // rticVerticalDetailsElement.appendChild(coreFunctions.createElementHelper("span", {class:`rticVerticalTitle existingListName${(this.locked) ? " rticLocked": ""}`, innerHTML: `<span>${this.name}</span>`}));

            rticVerticalDetailsElement.appendChild(coreFunctions.createElementHelper("a", {
                title: "See full list",
                class: `existingListName${(this.locked) ? " rticLocked": ""}`,
                href: `${(this.locked) ? "": `${urlPath}/explore?rtic=${encodeURIComponent(this.sectorCode)}`}&vertical=${encodeURIComponent(this.code)}`,
                innerHTML: `<span>${this.name}</span>`
            }));

            extraDetailsHolder = rticVerticalsHolder.appendChild(coreFunctions.createElementHelper("ul", {
                class: "extraDetailsHolder rticVerticalExtraDetailsHolder"
            }));
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {
                innerHTML: `<div class='label'>Code</div><div class='field'>${this.code}</div>`
            }));
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {
                innerHTML: `<div class='label'>Companies</div><div class='field'>${(this.companies) ? this.companies.toLocaleString(): "Unavailable"}</div>`
            }));
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {
                innerHTML: `<div class='label'>Description</div><div class='field'>${(this.description) ? this.description : "Unavailable"}</div>`
            }));

            // TODO
            // if (this.locked === true) {
            //     listDetailsElement.appendChild(coreFunctions.createElementHelper("button", {class:"unlock", innerHTML: "subscribe to unlock"}, {click: function() {coreFunctions.showOverlay("subscribe")}}));
            // }

            return rticVerticalsHolder;
        }

        // Toggle visibilty of extra details
        extraDetailsButtonClick(element) {
            element.closest(".rticVerticalHolder").classList.toggle("extraDetailsVisible");
        }

        showRticSectorExtraDetails(scrollToElement = false) {
            let listElement;
            if (listElement = document.querySelector(`#existingListsSection .existingList.rticVerticalHolder[data-code='${this.code}']`)) {
                let scrollTimeout = listElement.classList.contains("extraDetailsVisible") ? 0 : 500;
                listElement.classList.add("extraDetailsVisible");
                if (scrollToElement) {
                    setTimeout(() => this.scrollToRticVerticalElement(listElement), scrollTimeout);
                }
            }
            return this;
        }

        scrollToRticVerticalElement(element) {
            element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            return this;
        }


    }

    const allRtics = new AllRtics();

    return {
        pageBodyLoad: pageBodyLoad,
        allRtics: allRtics
    }
}();
